module.exports = __webpack_public_path__ + "img/thumb-iv.6813726.jpg";